function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 15A7 7 0 108 1a7 7 0 000 14zm8-7A8 8 0 110 8a8 8 0 0116 0z",
  clipRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.5 3a.5.5 0 01.5.5v5.21l3.248 1.856a.5.5 0 01-.496.868l-3.5-2A.5.5 0 017 9V3.5a.5.5 0 01.5-.5z",
  clipRule: "evenodd"
});

function SvgTime(props) {
  return React.createElement("svg", _extends({
    className: "time_svg__bi time_svg__bi-clock",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYmkgYmktY2xvY2siIHdpZHRoPSIxZW0iIGhlaWdodD0iMWVtIiB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDE1QTcgNyAwIDEwOCAxYTcgNyAwIDAwMCAxNHptOC03QTggOCAwIDExMCA4YTggOCAwIDAxMTYgMHoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNSAzYS41LjUgMCAwMS41LjV2NS4yMWwzLjI0OCAxLjg1NmEuNS41IDAgMDEtLjQ5Ni44NjhsLTMuNS0yQS41LjUgMCAwMTcgOVYzLjVhLjUuNSAwIDAxLjUtLjV6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+";
export { SvgTime as ReactComponent };